import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRectangle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 356,
	height: 191,
	viewBox: "0 0 356 191",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: .5,
		width: 355,
		height: 190,
		rx: 9.5,
		fill: "none",
		strokeDasharray: "10 10"
	})
});
export default SvgRectangle;
